// Analytics tracking - simplified version without analytics_logs table

export const trackEvent = async (eventType: string, metadata?: Record<string, any>) => {
  try {
    // Track in Google Analytics only (analytics_logs table was removed)
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', eventType, metadata);
    }
    
    // Log to console in development
    if (import.meta.env.DEV) {
      console.log('[Analytics]', eventType, metadata);
    }
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};
